module.exports = __webpack_public_path__ + "img/incomplete_left.275c393d.jpg";